import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsIntegrations(tenant: Tenant): Faq[] {
	return [
		{
			question: "Vyplatí se investice do integrace firemních systémů nebo aplikací?",
			answer:
				"Z dlouhodobého hlediska rozhodně ano. Integrace vám ušetří čas, sníží množství manuální práce, eliminuje chyby při přenosu dat nebo zefektivní firemní procesy.",
		},
		{
			question: "Které technologie při integraci využíváte?",
			answer: "Využíváme API, middleware, datové konektory nebo integrační platformy.",
		},
		{
			question: "Jak dlouho proces integrace trvá?",
			answer:
				"Na tuto otázku neexistuje univerzální odpověď. Doba integrace závisí na složitosti systémů a požadovaných funkcích. Jednoduchá integrace může trvat pár dní, komplexní řešení delší dobu.",
		},
		{
			question: "V souvislost s integrací jsme narazili na zkratku API. Co to znamená?",
			answer:
				"API (Application Programming Interface) je rozhraní, které aplikacím umožňuje mezi sebou komunikovat. Většina moderních systémů využívá API jako prostředek pro integraci.",
		},
		{
			question: "Umíte zařídit také integraci s externími systémy?",
			answer:
				"Ano, pro klienty děláme také integraci s externími systémy a nástroji. Například pro síť zásilkových míst OX Point jsme řešili integraci se světovými a lokálními dopravci.",
		},
		{
			question: "Musíme před integrací v systémech dělat nějaké zásadní úpravy?",
			answer:
				"Většinou není nutné provádět úpravy, ale záleží na konkrétním systému a situaci. Vše s vámi podrobně zkonzultujeme ještě před zahájením integrace.",
		},
	];
}
